import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { CustomerDataProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { TableAsync } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CustomerEconomyDetails: React.FC<CustomerDataProps> = (props) => {
  return (
    <TableAsync<ApiModel.Customer>
      properties={{
        paymentTerms: {
          description: TranslationKeys.Customer.PaymentTerms,
          formatter: () =>
            props.customer?.paymentTerms
              ? `${props.customer?.paymentTerms} ${LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Common.Days
                )}`
              : "",
          classification: "number",
        },
      }}
      filter={[props.customer ?? ({} as ApiModel.Customer)]}
      pagination={false}
      disableSort
    />
  );
};
export default CustomerEconomyDetails;
